// extracted by mini-css-extract-plugin
module.exports = {"spinAround":"spinAround___26srO"};